import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-purchase-sell-stock",
  "use": "icon-purchase-sell-stock-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-purchase-sell-stock\">\n\t<path d=\"M0 0h24v24H0z\" fill=\"none\" />\n\t<path fill=\"currentColor\" d=\"M3 6.25A3.25 3.25 0 0 1 6.25 3h11.5A3.25 3.25 0 0 1 21 6.25v11.5A3.25 3.25 0 0 1 17.75 21H6.25A3.25 3.25 0 0 1 3 17.75zm1.5 6.25v5.25c0 .966.784 1.75 1.75 1.75H14v-7zM14 11V4.5H6.25A1.75 1.75 0 0 0 4.5 6.25V11zm5.5-1.5h-4v5h4zm0 6.5h-4v3.5h2.25a1.75 1.75 0 0 0 1.75-1.75zm0-8V6.25a1.75 1.75 0 0 0-1.75-1.75H15.5V8z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol